<!------------ START TEMPLATE ------------>
<template>
  <div>
    <!------------ START FORM ------------>
    <form role="form" @submit.stop.prevent="onSubmit">
      <div class="con-vs-tabs vs-tabs vs-tabs-position-top">
        <div class="con-ul-tabas vs-tabs-primary">
          <ul class="ul-tabs vs-tabs--ul ul-tabs-left">
            <li class="vs-tabs--li" :class="passo === 0 ? 'activeChild' : ''">
              <button @click="passo = 0" type="button" class="vs-tabs--btn">
                <span>Geral</span>
              </button>
            </li>
            <li class="vs-tabs--li" :class="passo === 1 ? 'activeChild' : ''">
              <button @click="passo = 1" type="button" class="vs-tabs--btn">
                <span>Avançado</span>
              </button>
            </li>
          </ul>
        </div>

        <!-- Tab body Geral -->
        <div :class="passo === 0 ? 'div-show' : 'div-hide'">
          <div class="vx-row mb-6 mt-5">
            <div class="vx-col w-full">
              <span>Nome</span>
              <vs-input
                size="large"
                class="w-full"
                name="Nome"
                id="Nome"
                v-model="formCadastro.nomeProduto"
                v-validate="{ required: true, min: 3 }"
                :state="validateState('Nome')"
                :danger="validateClass('Nome')"
                val-icon-danger="clear"
                danger-text="Preencha este Campo"
              />
            </div>
          </div>

          <div class="vx-row mb-6 mt-5">
            <div class="vx-col w-full">
              <span>Nome Resumido</span>
              <vs-input
                size="large"
                class="w-full"
                name="Nome Resumido"
                id="Nome Resumido"
                v-model="formCadastro.nomeProdutoResumo"
                v-validate="{ required: true, min: 3 }"
                :state="validateState('Nome Resumido')"
                :danger="validateClass('Nome Resumido')"
                val-icon-danger="clear"
                danger-text="Preencha este Campo"
              />
            </div>
          </div>

          <div class="vx-row mb-6">
            <div class="vx-col w-full">
              <span>Tipo de Produto</span>

              <vs-select
                v-model="formCadastro.idTipoProduto"
                class="select-large w-full"
                name="Tipo de Produto"
                v-validate="{ required: true }"
                :state="validateState('Tipo de Produto')"
                :danger="validateClass('Tipo de Produto')"
                @input="selecionaTipo()"
              >
                <vs-select-item
                  :key="index"
                  :value="item.id"
                  :text="item.label"
                  v-for="(item, index) in tipoProdutos"
                />
              </vs-select>
            </div>
          </div>

          <!-- Valor mínimo mensalidade -->
          <div
            class="vx-row mb-6"
            v-if="formCadastro.idTipoProduto == TIPO_PRODUTO.ADESAO"
          >
            <div class="vx-col">
              <vs-checkbox
                v-model="formCadastro.isValorMinimoMensalidade"
                @input="getRegionais()"
              >
                O valor mínimo deve ser igual ao valor da mensalidade
              </vs-checkbox>
            </div>
          </div>

          <!-- Regionais (valor mínimo) -->
          <div
            class="vx-row"
            v-if="formCadastro.isValorMinimoMensalidade && listRegionais.length"
          >
            <div class="vx-col w-full mb-6">
              <span class="mb-1 block">Aplicar valor mínimo nas Regionais</span>
              <v-select
                multiple
                :options="listRegionais"
                name="regionais"
                id="regionais"
                :reduce="(item) => item.id"
                v-model="formCadastro.idsRegionaisValorMinimoMensalidade"
                :state="validateState('regionais')"
                :class="validateClass('regionais')"
              ></v-select>
            </div>
          </div>

          <div class="vx-row mb-6">
            <!-- Percentual Baseado Fipe -->
            <div
              v-if="formCadastro.idTipoProduto == TIPO_PRODUTO.ADESAO"
              class="vx-col w-1/2"
            >
              <span>Percentual Baseado Fipe</span>

              <money
                v-bind="percent"
                class="w-full vs-inputx vs-input--input large"
                name="Percentual Fipe"
                v-model.lazy="formCadastro.valorBaseadoFipe"
                id="Percentual Fipe"
                v-model="formCadastro.valorBaseadoFipe"
                v-validate="{ required: true }"
                :state="validateState('Percentual Fipe')"
                :danger="validateClass('Percentual Fipe')"
              ></money>
            </div>

            <!-- Percentual de Desconto Máximo -->
            <div
              v-if="
                this.formCadastro.idTipoProduto !== 8 &&
                this.formCadastro.idTipoProduto !== 17
              "
              :class="`vx-col ${
                formCadastro.idTipoProduto == TIPO_PRODUTO.ADESAO
                  ? 'w-1/2'
                  : 'w-full'
              }`"
            >
              <span>Percentual de Desconto Máximo</span>
              <vs-input
                type="number"
                size="large"
                class="w-full"
                name="Percentual de Desconto"
                id="Percentual de Desconto"
                v-model="formCadastro.porcentagemDescontoMaxima"
                v-validate="{ required: true }"
                :state="validateState('Percentual de Desconto')"
                :danger="validateClass('Percentual de Desconto')"
                val-icon-danger="clear"
                danger-text="Preencha este Campo"
              />
            </div>
          </div>

          <div class="vx-row mb-3">
            <div class="vx-col w-full">
              <vs-checkbox v-model="selecionarPerfisDesconto">
                Selecionar perfis que podem dar o desconto
              </vs-checkbox>
            </div>
          </div>

          <div v-if="selecionarPerfisDesconto" class="vx-row">
            <div class="vx-col w-full mb-6">
              <v-select
                multiple
                :options="perfis"
                name="Perfil"
                id="Perfil"
                v-model="perfisDesconto"
                :state="validateState('Perfil')"
                :class="validateClass('Perfil')"
              ></v-select>
              <br />

              <vs-list-item
                v-for="item in formCadastro.perfisDescontoSelecionados"
                :key="item.id"
                :title="item.label"
              >
                <span>{{ item.percentual }}%</span>

                <template slot="avatar">
                  <div class="flex">
                    <vs-button
                      @click.stop.prevent="editaTipoDescontoPerfil(item)"
                      class="mr-2 text-default"
                      color="primary"
                      type="border"
                      icon="edit"
                    ></vs-button>
                    <vs-button
                      @click="deletaTipoDescontoPerfil(item.id)"
                      class="mr-2 text-default"
                      color="danger"
                      type="border"
                      icon="clear"
                    ></vs-button>
                  </div>
                </template>
              </vs-list-item>
            </div>
          </div>

          <div class="vx-row">
            <div class="vx-col w-full mb-6 mt-2">
              <span class="mb-1 block"
                >Produto não será aplicado as regionais:</span
              >
              <v-select
                multiple
                :options="listRegionais"
                name="regionaisIgnoradas"
                id="regionaisIgnoradas"
                :reduce="(item) => item.id"
                v-model="formCadastro.idsRegionaisIgnoradas"
                :state="validateState('regionaisIgnoradas')"
                :class="validateClass('regionaisIgnoradas')"
              ></v-select>
            </div>
          </div>

          <div class="vx-row">
            <div class="vx-col w-1/2 mb-6">
              <span>Valor Fixo ou Tabelado</span>
              <vs-switch
                color="success"
                v-model="formCadastro.isValorFixo"
                style="width: 80px"
              >
                <span slot="on">Fixo</span>
                <span slot="off">Tabelado</span>
              </vs-switch>
            </div>

            <div class="vx-col w-1/2 mb-6">
              <span>É produto complementar?</span>
              <vs-switch
                color="success"
                v-model="formCadastro.isComplementar"
                style="width: 80px"
              >
                <span slot="on">Sim</span>
                <span slot="off">Não</span>
              </vs-switch>
            </div>
          </div>

          <!-- Tipos de Acréscimos -->
          <div
            class="vx-row mb-6"
            v-if="formCadastro.idTipoProduto === TIPO_PRODUTO.MENSALIDADE"
          >
            <div class="vx-col w-full flex mb-2">
              Acréscimo porcentual na mensalidade caso o veículo não possua
              estacionamento privado
              <vs-button
                color="success"
                icon="add"
                size="small"
                @click.stop.prevent="activePromptAcrescimo = true"
              />
            </div>

            <div class="vx-col w-full">
              <vs-list-item
                v-for="(item, index) in acrescimosMensalidadeEscolhidos"
                :key="index"
                title="Acréscimo do valor da mensalidade: "
                :subtitle="
                  item.uf.length > 0 ? item.uf.join(', ') : 'Todos os Estados'
                "
              >
                <span>{{ item.valor }}%</span>
                <template slot="avatar">
                  <vs-button
                    @click.stop.prevent="
                      acrescimosMensalidadeEscolhidos.splice(index, 1)
                    "
                    class="mr-2"
                    color="primary"
                    type="border"
                    icon="clear"
                  ></vs-button>
                </template>
              </vs-list-item>
              <small v-if="acrescimosMensalidadeEscolhidos.length > 0"
                >Observação: configurações de acréscimos por estados específicos
                sobrepõem configurações para todos os estados.</small
              >
            </div>
          </div>

          <div class="vx-row mb-4">
            <div class="vx-col w-full">
              <span>Grupos</span>
              <v-select
                :options="grupos"
                name="Grupos"
                id="Grupos"
                v-model="grupo"
                :state="validateState('Grupos')"
                :class="validateClass('Grupos')"
              ></v-select>
              <br />
              <vs-list-item
                v-for="item in gruposVeiculos"
                :key="item.idGrupo"
                :title="item.nomeGrupo"
                :subtitle="exibeValor(item.valor)"
              >
                <template slot="avatar">
                  <vs-button
                    @click="deletaGrupoVeiculo(item.idGrupo)"
                    class="mr-2 text-default"
                    color="danger"
                    type="border"
                    icon="clear"
                  ></vs-button>
                </template>
              </vs-list-item>
            </div>
          </div>

          <!-- Cota de participação -->

          <div
            v-if="formCadastro.idTipoProduto == TIPO_PRODUTO.CASCO"
            class="vs-col flex gap-10 mb-4"
          >
            <div class="vx-row">
              <span>Percentual de participação </span><br />
              <vs-number
                style="padding: 10px"
                class="w-full vs-inputx vs-input--input medium"
                name="Valor da Cota"
                id="valorCota"
                v-model="formCadastro.valorCotaParticipacao"
                :state="validateState('valorCota')"
                :danger="validateClass('valorCota')"
              ></vs-number>
            </div>

            <div class="vx-row">
              <span>Valor mínimo de participação</span><br />
              <vs-number
                style="padding: 10px"
                class="w-full vs-inputx vs-input--input medium"
                name="Valor da Participação"
                id="valorParticipacao"
                v-model="formCadastro.valorParticipacaoMinimo"
                :state="validateState('valorParticipacao')"
                :danger="validateClass('valorParticipacao')"
              ></vs-number>
            </div>
          </div>

          <!-- Cota de participação -->

          <div class="vx-row mb-3">
            <div
              v-if="
                this.formCadastro.idTipoProduto !== 8 &&
                this.formCadastro.idTipoProduto !== 17
              "
              class="vx-col w-full"
            >
              <span>Tipos de Descontos</span>
              <v-select
                :options="tiposDeDescontos"
                name="tiposDeDescontos"
                id="tiposDeDescontos"
                v-model="tiposDescontos"
              ></v-select>
              <br />
              <vs-list-item
                v-for="item in DescontoEscolhido"
                :key="item.idTipoDesconto"
                :title="item.descricao"
                :subtitle="item.status"
              >
                <span v-if="item.estados" class="mr-5">
                  {{ item.estados }}</span
                >
                <span>{{ item.percentualMaximoDesconto }}%</span>

                <vs-button
                  class="text-default"
                  radius
                  v-tooltip="'Detalhes'"
                  color="primary"
                  type="gradient"
                  icon-pack="feather"
                  icon="icon-search"
                  @click.stop.prevent="detalhesTipoDesconto(item)"
                ></vs-button>

                <template slot="avatar">
                  <div class="flex">
                    <vs-button
                      @click.stop.prevent="editaTipoDesconto(item)"
                      class="mr-2 text-default"
                      color="primary"
                      type="border"
                      icon="edit"
                    ></vs-button>
                    <vs-button
                      @click.stop.prevent="
                        deletaTipoDesconto(item.idTipoDesconto)
                      "
                      class="mr-2 text-default"
                      color="danger"
                      type="border"
                      icon="clear"
                    ></vs-button>
                  </div>
                </template>
              </vs-list-item>
            </div>
          </div>

          <div class="vx-row mb-6">
            <div class="vx-col w-full">
              <span>Formas de Pagamento</span>
              <v-select
                :options="formasPagamentos"
                name="Formas de Pagamento"
                id="Formas de Pagamento"
                v-model="formCadastro.formasPagamentos"
                multiple
                v-validate="{ required: true }"
                :state="validateState('Formas de Pagamento')"
                :class="validateClass('Formas de Pagamento')"
                danger-text="Preencha este Campo"
              ></v-select>
              <small>Selecione uma ou mais</small>
            </div>
          </div>

          <div class="vx-row mb-6">
            <div class="vx-col w-full">
              <span>Produtos Linkados</span>
              <v-select
                :options="productsSelect"
                name="Produtos Linkados"
                id="Produtos Linkados"
                v-model="formCadastro.produtosLinkados"
                multiple
                :state="validateState('Produtos Linkados')"
                :class="validateClass('Produtos Linkados')"
              ></v-select>
              <small>Selecione um ou mais</small>
            </div>
          </div>

          <div
            v-if="formCadastro.idTipoProduto === TIPO_PRODUTO.CASCO"
            class="vx-row mb-6"
          >
            <div class="vx-col w-full">
              <span>Produtos Complementares ao Casco</span>
              <v-select
                :options="produtosComplementares"
                name="Produtos Complementares ao Casco"
                id="Produtos Complementares ao Casco"
                v-model="formCadastro.produtosComplementares"
                multiple
                :state="validateState('Produtos Complementares ao Casco')"
                :class="validateClass('Produtos Complementares ao Casco')"
              ></v-select>
              <small>Selecione um ou mais</small>
            </div>
          </div>

          <div class="vx-row mb-6">
            <div class="vx-col w-full">
              <span>Sobrepõe outros Produtos</span>
              <v-select
                :options="productsSelect"
                name="Sobrepõe outros Produtos"
                id="Sobrepõe outros Produtos"
                v-model="formCadastro.sobreporOutrosProdutos"
                multiple
                :state="validateState('Sobrepõe outros Produtos')"
                :class="validateClass('Sobrepõe outros Produtos')"
              ></v-select>
              <small>Selecione um ou mais</small>
            </div>
          </div>

          <div class="vx-row mb-6">
            <div class="vx-col w-full">
              <span>Aplicar produto para:</span>
              <v-select
                :options="destinos"
                name="destinos"
                id="destinos"
                multiple
                v-model="formCadastro.destinos"
              ></v-select>
              <small>Selecione uma ou mais</small>
            </div>
          </div>

          <div class="vx-row mb-6">
            <div class="vx-col w-full">
              <span>Este é um Produto Evo?</span>

              <vs-select
                v-model="formCadastro.idProdutoEvo"
                class="select-large w-full"
                name="Produto Evo"
                :state="validateState('Produto Evo')"
                :danger="validateClass('Produto Evo')"
              >
                <vs-select-item
                  :key="index"
                  :value="item.id"
                  :text="item.label"
                  v-for="(item, index) in produtosEvo"
                />
              </vs-select>
            </div>
          </div>

          <div class="vx-row mb-6" v-if="fornecedoresFiltred.length > 0">
            <div class="vx-col w-full">
              <span>Fornecedor</span>

              <vs-select
                v-model="formCadastro.idFornecedor"
                class="select-large w-full"
                name="Fornecedor"
                :state="validateState('Fornecedor')"
                :danger="validateClass('Fornecedor')"
              >
                <vs-select-item
                  :key="index"
                  :value="item.id"
                  :text="item.label"
                  v-for="(item, index) in fornecedoresFiltred"
                />
              </vs-select>
            </div>
          </div>
        </div>

        <!-- Avançado -->
        <div :class="passo === 1 ? 'div-show' : 'div-hide'">
          <div class="vx-row firstInputTab">
            <div class="vx-col mb-6">
              <span>Ativo</span>
              <vs-switch
                color="success"
                v-model="formCadastro.status"
                style="width: 60px"
              >
                <span slot="on">Ativo</span>
                <span slot="off">Inativo</span>
              </vs-switch>
            </div>
          </div>

          <div class="vx-row">
            <div class="vx-col mb-6">
              <span>Obrigatório na Proposta</span>
              <vs-switch
                color="success"
                v-model="formCadastro.obrigatorio"
                style="width: 60px"
              >
                <span slot="on">Sim</span>
                <span slot="off">Não</span>
              </vs-switch>
            </div>
          </div>

          <div class="vx-row">
            <div class="vx-col mb-6">
              <span>Valor Cobrado Mensalmente</span>
              <vs-switch
                color="success"
                v-model="formCadastro.isMensal"
                style="width: 60px"
              >
                <span slot="on">Sim</span>
                <span slot="off">Não</span>
              </vs-switch>
            </div>
          </div>

          <div class="vx-row">
            <div class="vx-col mb-6">
              <span>Valor visível da Proposta</span>
              <vs-switch
                color="success"
                v-model="formCadastro.visivelProposta"
                style="width: 60px"
              >
                <span slot="on">Sim</span>
                <span slot="off">Não</span>
              </vs-switch>
            </div>
          </div>

          <!--div class="vx-row">
          <div class="vx-col mb-6">
            <span>Produto de Desconto?</span>
            <vs-switch
              color="success"
              v-model="formCadastro.isDesconto"
              style="width: 60px"
            >
              <span slot="on">Sim</span>
              <span slot="off">Não</span>
            </vs-switch>
          </div>
        </div-->

          <div class="vx-row">
            <div class="vx-col mb-6">
              <span>Produto Adicional (fora da proposta)</span>
              <vs-switch
                color="success"
                v-model="formCadastro.isAdicional"
                style="width: 60px"
              >
                <span slot="on">Sim</span>
                <span slot="off">Não</span>
              </vs-switch>
            </div>
          </div>

          <div class="vx-row">
            <div class="vx-col mb-6">
              <span>Em caso de remoção exige Assinatura de Termo?</span>
              <vs-switch
                color="success"
                v-model="formCadastro.requerAssinaturaTermoAdicional"
                style="width: 60px"
              >
                <span slot="on">Sim</span>
                <span slot="off">Não</span>
              </vs-switch>
            </div>
          </div>

          <div class="vx-row">
            <div class="vx-col mb-6">
              <span>Produto aparece na proposta?</span>
              <vs-switch
                color="success"
                v-model="formCadastro.produtoVisivel"
                style="width: 60px"
                id="produtoVisivel"
                name="produtoVisivel"
              >
                <span slot="on">Sim</span>
                <span slot="off">Não</span>
              </vs-switch>
            </div>
          </div>

          <div class="vx-row" v-if="bemProtege">
            <div class="vx-col mb-6">
              <span>Produto pode ter seu valor alterado na Cotação?</span>
              <vs-switch
                color="success"
                v-model="formCadastro.alterarValor"
                style="width: 60px"
                id="alterarValor"
                name="alterarValor"
              >
                <span slot="on">Sim</span>
                <span slot="off">Não</span>
              </vs-switch>
            </div>
          </div>
        </div>
      </div>

      <!-----============================ OBS: No status deve ter um campo SELECT que irá trazer as opções criadas pelo usuário na parte cadastro de Status do Menu USUARIO  ==================------->

      <vs-alert
        v-if="$validator.errors.all().length > 0"
        color="danger"
        title="Atenção!!"
        active="true"
        class="my-3"
        style="height: auto !important"
      >
        <ul>
          <li
            class="mb-2"
            v-for="error in $validator.errors.all()"
            :key="error.id"
          >
            {{ error }}
          </li>
        </ul>
      </vs-alert>

      <!-- botões de cancelar salvar -->
      <div class="vx-row mb-5">
        <div class="vx-col w-full text-right">
          <vs-button
            color="warning"
            type="border"
            class="mr-3 mb-2"
            @click.stop.prevent="onReset"
            >Cancelar</vs-button
          >
          <BotaoSubmit
            variant="success"
            :edit="this.dados.idProduto == null ? false : true"
            :aguarde="aguardeCadastro"
          ></BotaoSubmit>
        </div>
      </div>

      <div class="mt-6 mb-6"></div>

      <vs-popup
        class="holamundo"
        title="Informações de Valor do Produto"
        @cancel="clearFormGrupo"
        @accept="adicionaGrupoProduto"
        :active.sync="activePromptValor"
      >
        <div>
          Informe o Valor deste produto para o Grupo
          <b>{{ preencheGrupo() }}</b
          >.
          <money
            class="w-full vs-inputx vs-input--input large"
            placeholder="Valor"
            v-model="valorGrupo"
            name="Valor do produto"
            id="Valor do produto"
            v-validate="{ required: true, min: 0 }"
            :state="validateState('Valor do produto')"
            :class="validateClass('Valor do produto')"
          />
          <vs-button
            color="success"
            class="w-full mt-2"
            @click="adicionaGrupoProduto"
            >Salvar</vs-button
          >
        </div>
      </vs-popup>

      <vs-popup
        class="holamundo"
        title="Informações do Percentual do Desconto"
        :active.sync="activePromptDesconto"
        @cancel="clearFormDescontos"
        @close="clearFormDescontos"
      >
        <div>
          Informe o percentual para o tipo de desconto:
          <b>{{ preencheTipoDesconto() }}</b>

          <div class="vx-row mt-4">
            <div class="vx-col w-full">
              Selecione os estados:
              <v-select
                class="mt-3"
                :options="estados"
                name="Estado"
                id="Estado"
                v-model="estado"
                :reduce="(item) => item.label"
                multiple
              ></v-select>
              <br />
            </div>
          </div>

          <div class="vx-row mb-2">
            <div class="vx-col w-full">
              <span>Selecione os grupos:</span>
              <v-select
                class="mt-3"
                :options="grupos"
                name="GruposDesconto"
                id="GruposDesconto"
                v-model="gruposDesconto"
                :reduce="(item) => item.label"
                multiple
              ></v-select>
              <br />
            </div>
          </div>

          <div class="vx-row mb-2">
            <div class="vx-col w-full">
              Selecione o tipo de proposta:
              <v-select
                class="mt-3 mb-2"
                :options="tiposProposta"
                name="TiposProposta"
                id="TiposProposta"
                v-model="tipoProposta"
              ></v-select>
              <br />
            </div>
          </div>

          <div class="vx-row mb-2">
            <div class="vx-col w-full">
              Selecione o intervalo de valor da FIPE:
              <div class="flex gap-3">
                <money
                  class="vx-col w-1/2 mt-3 mb-2 vs-inputx vs-input--input large"
                  name="TiposProposta"
                  id="TiposProposta"
                  v-model="valorFipeInicial"
                  v-model.lazy="valorFipeInicial"
                />
                <money
                  class="vx-col w-1/2 mt-3 mb-2 vs-inputx vs-input--input large"
                  name="TiposProposta"
                  id="TiposProposta"
                  v-model="valorFipeFinal"
                  v-model.lazy="valorFipeFinal"
                />
              </div>
              <br />
            </div>
          </div>

          Digite o percentual:
          <money
            v-bind="percent"
            class="w-full vs-inputx vs-input--input large my-2"
            v-model.lazy="percentualDesconto"
            v-model="percentualDesconto"
            name="Valor do produto"
            id="Valor do produto"
            v-validate="{ required: true }"
          />
          <vs-button
            color="success"
            class="w-full mt-2"
            @click="adicionaTipoDeDesconto"
            >Salvar</vs-button
          >
        </div>
      </vs-popup>

      <!-- TESTE DE POPUP -->

      <vs-popup
        title="Desconto para perfil"
        :active.sync="activePromptDescontoPerfil"
        @cancel="clearFormDescontosPerfil"
        @close="clearFormDescontosPerfil"
      >
        <div>
          Informe o percentual que pode ser aplicado para o desconto:
          <b>{{ preenchePerfilDesconto() }}</b>

          Digite o percentual:
          <money
            v-bind="percent"
            class="w-full vs-inputx vs-input--input large my-2"
            v-model.lazy="percentualDescontoPerfil"
            v-model="percentualDescontoPerfil"
            name="Valor do produto"
            id="Valor do produto"
            v-validate="{ required: true }"
          />

          <vs-button
            color="success"
            class="w-full mt-2"
            @click="adicionaTipoDeDescontoPerfil"
            >Salvar</vs-button
          >
        </div>
      </vs-popup>

      <vs-popup
        class="holamundo"
        title="Detalhes do tipo de Desconto"
        :active.sync="detalhesDesconto"
      >
        <table class="table table-bordered">
          <tr v-if="auxDetalhesDesconto.gruposDesconto">
            <th class="uppercase">GRUPOS SELECIONADOS:</th>
            <td>{{ auxDetalhesDesconto.gruposDesconto }}</td>
          </tr>
          <tr v-if="auxDetalhesDesconto.estados">
            <th class="uppercase">ESTADOS SELECIONADOS:</th>
            <td>{{ auxDetalhesDesconto.estados }}</td>
          </tr>
          <tr v-if="auxDetalhesDesconto.tipoProposta">
            <th class="uppercase">TIPO DE PROPOSTA:</th>
            <td>{{ auxDetalhesDesconto.tipoProposta }}</td>
          </tr>
          <tr v-if="auxDetalhesDesconto.percentualMaximoDesconto">
            <th class="uppercase">PORCENTAGEM APLICADA:</th>
            <td>{{ auxDetalhesDesconto.percentualMaximoDesconto }}%</td>
          </tr>
          <tr
            v-if="
              auxDetalhesDesconto.valorFipeInicial ||
              auxDetalhesDesconto.valorFipeFinal
            "
          >
            <th class="uppercase">INTERVALO DE VALOR DA FIPE:</th>
            <td>
              R${{
                parseFloat(auxDetalhesDesconto.valorFipeInicial).toFixed(2)
              }}
              à R${{
                parseFloat(auxDetalhesDesconto.valorFipeFinal).toFixed(2)
              }}
            </td>
          </tr>
        </table>
      </vs-popup>

      <!-- Modal do Acréscimo da Mensalidade -->
      <vs-popup
        title="Informações do Percentual do Acréscimo da Mensalidade"
        :active.sync="activePromptAcrescimo"
        @cancel="limpaAcrescimo"
      >
        <div>
          Informe o percentual para o acréscimo da mensalidade para quando o
          veículo não possuir estacionamento privado.

          <div class="vx-row mb-2 mt-4">
            <div class="vx-col w-full">
              Selecione os estados:
              <v-select
                class="mt-3 mb-2"
                :options="estados"
                v-model="estadoAcrescimo"
                :reduce="(item) => item.label"
                multiple
              ></v-select>
              <br />
            </div>
          </div>

          Digite o percentual:
          <money
            v-money="money"
            class="w-full vs-inputx vs-input--input large"
            v-model="porcentagemAcrescimo"
            name="porcentagemAcrescimo"
            id="porcentagemAcrescimo"
            v-validate="{ required: true, min: 0 }"
            :state="validateState('porcentagemAcrescimo')"
            :class="validateClass('porcentagemAcrescimo')"
          />
          <vs-button
            color="success"
            class="w-full mt-2"
            @click.stop.prevent="adicionaAcrescimo"
            >Salvar</vs-button
          >
        </div>
      </vs-popup>
    </form>
    <!------------ END FORM ------------>
  </div>
</template>
<!------------ END TEMPLATE ------------>

<!------------ START SCRIPT ------------>
<script>
import * as lang from 'vuejs-datepicker/src/locale';
import vSelect from 'vue-select';
import 'vue-select/dist/vue-select.css';
import service from '../../services';
import BotaoSubmit from '../../components/BotaoSubmit';
import { VMoney, Money } from 'v-money';
import jwt from 'jsonwebtoken';
import functions from '../../utils/functions.js';
import { TIPO_PRODUTO } from '../../commons/dicionarioTipoProduto';
import regionaisService from './../../services/regionais';
import notify from '../../utils/notify';
import { decryptData } from '../../services/decryptData';

export default {
  props: {
    sideBar: {
      type: Boolean,
    },
    dados: {
      type: Object,
    },
  },
  watch: {
    dados() {
      this.preencheForm();
    },
    selecionarPerfisDesconto() {
      if (!this.selecionarPerfisDesconto) {
        this.perfisDesconto = [];
      }
    },
    grupo(value) {
      if (value.length != 0) {
        if (this.formCadastro.isValorFixo == true)
          this.activePromptValor = true;
        else this.adicionaGrupoProduto();
      }
    },
    tiposDescontos(value) {
      if (value) {
        if (value.length !== 0) {
          this.activePromptDesconto = true;
        } else {
          this.activePromptDesconto = false;
          this.tiposDescontos = '';
        }
      }

      if (value == null || value == undefined) {
        this.tiposDescontos = '';
      }
    },
    perfisDesconto(value) {
      if (!value || value.length === 0) {
        this.activePromptDescontoPerfil = false;
        return;
      }

      const selectedPerfil = value[0];

      if (!this.formCadastro.perfisDescontoSelecionados) {
        this.showDescontoPopup(selectedPerfil);
        return;
      }

      const existPerfil = this.formCadastro.perfisDescontoSelecionados.find(
        ({ id }) => id === selectedPerfil.id,
      );

      if (!existPerfil) {
        this.showDescontoPopup(selectedPerfil);
      }
    },
    formCadastro: {
      handler: function () {
        if (
          this.formCadastro.isComplementar == true &&
          this.formCadastro.idTipoProduto == TIPO_PRODUTO.CASCO
        ) {
          this.formCadastro.idTipoProduto = null;
          this.formCadastro.isComplementar = false;
          notify.notifyFail(
            this.$vs,
            'Um produto não pode ser do tipo Casco e Complementar ao mesmo tempo.',
          );
        }
      },
      deep: true,
    },
  },
  data() {
    return {
      percent: {
        decimal: '.',
        thousands: '',
        prefix: '',
        suffix: '%',
        precision: 2,
      },
      passo: 0,
      activePromptValor: false,
      activePromptDesconto: false,
      activePromptAcrescimo: false,
      aguardeCadastro: false,
      valorGrupo: 0.0,
      percentualDesconto: 0.0,
      idEmpresa: null,
      grupos: [],
      gruposVeiculos: [],
      formasPagamentos: [],
      tiposDeDescontos: [],
      tiposDescontos: [],
      DescontoEscolhido: [],
      destinos: ['Veículo', 'Associado', 'Dependente'],
      formaPagamento: null,
      languages: lang,
      grupo: [],
      produtos: [],
      produtosComplementares: [],
      produtosEvo: [],
      estados: [],
      estado: [],
      estadoAcrescimo: [],
      span: '',
      spanEstado: '',
      spanProposta: '',
      estadoString: '',
      fornecedores: [],
      fornecedoresFiltred: [],
      tipoProdutos: [],
      productsSelect: [],
      perfis: [],
      funcoesValicao: null,
      formCadastro: {
        idEmpresa: null,
        isValorFixo: true,
        isMensal: null,
        status: true,
        nomeProduto: '',
        nomeProdutoResumo: '',
        obrigatorio: null,
        formasPagamentos: null,
        tiposDeDescontos: null,
        grupos: null,
        porcentagemDescontoMaxima: null,
        visivelProposta: null,
        produtoVisivel: 1,
        alterarValor: null,
        destinos: [],
        produtosLinkados: null,
        sobreporOutrosProdutos: null,
        isAdicional: null,
        requerAssinaturaTermoAdicional: null,
        isDesconto: null,
        idProdutoEvo: null,
        idTipoProduto: null,
        idFornecedor: null,
        estado: null,
        valorBaseadoFipe: null,
        idsPerfilDesconto: null,
        produtosComplementares: null,
        isComplementar: null,
        valorCotaParticipacao: null,
        valorParticipacaoMinimo: null,
        isValorMinimoMensalidade: false,
        idsRegionaisValorMinimoMensalidade: [],
        idsRegionaisIgnoradas: null,
        descontosExcluidos: [],
        perfisDescontoSelecionados: [],
        acrescimoMensalidade: [],
      },
      acrescimosMensalidadeEscolhidos: [],
      tiposProposta: [
        'Adesão',
        'Reativação',
        'Substituição',
        'Inclusão',
        'Troca de Titularidade',
        'Migração',
      ],
      tipoProposta: '',
      selecionarPerfisDesconto: false,
      perfisDesconto: [],
      TIPO_PRODUTO: {
        ADESAO: TIPO_PRODUTO.TIPO_PRODUTO_ADESAO,
        CASCO: TIPO_PRODUTO.TIPO_PRODUTO_CASCO,
        MENSALIDADE: TIPO_PRODUTO.TIPO_PRODUTO_MENSALIDADE,
      },
      listRegionais: [],
      gruposDesconto: [],
      gruposDescontoString: '',
      detalhesDesconto: false,
      auxDetalhesDesconto: {},
      valorFipeInicial: 0,
      valorFipeFinal: 0,

      activePromptDescontoPerfil: false,
      percentualDescontoPerfil: 0.0,
      selectedPerfil: null,
      porcentagemAcrescimo: 0,
    };
  },
  directives: { money: VMoney },
  computed: {
    bemProtege() {
      return functions.verificaEmpresaBemProtege(this.idEmpresa);
    },
  },
  methods: {
    selecionaTipo() {
      this.formCadastro.idFornecedor = null;

      if (
        this.formCadastro.idTipoProduto == TIPO_PRODUTO.TIPO_PRODUTO_DESCONTO ||
        this.formCadastro.idTipoProduto ==
          TIPO_PRODUTO.TIPO_PRODUTO_DESCONTO_ADICIONAL
      ) {
        this.formCadastro.isDesconto = true;
      } else {
        this.formCadastro.isDesconto = false;
      }
      this.fornecedoresFiltred = this.fornecedores.filter(
        (x) => x.idTipoProduto == this.formCadastro.idTipoProduto,
      );
    },
    exibeValor(valor) {
      var retorno =
        this.formCadastro.isValorFixo == true
          ? this.$options.filters.currency(valor)
          : 'Valor a ser definido na tabela';
      return retorno;
    },
    deletaGrupoVeiculo(idGrupo) {
      let array = this.gruposVeiculos;
      for (var i = array.length - 1; i >= 0; i--) {
        if (array[i].idGrupo == idGrupo) {
          array.splice(i, 1);
        }
      }
    },
    deletaTipoDesconto(idTipoDesconto) {
      let array = this.DescontoEscolhido;

      for (let i = array.length - 1; i >= 0; i--) {
        if (array[i].idTipoDesconto == idTipoDesconto) {
          const [desconto] = array.splice(i, 1);

          this.formCadastro.descontosExcluidos.push(desconto);
        }
      }
    },
    preencheGrupo() {
      if (this.grupo.length == 0) {
        return '';
      } else {
        return this.grupo.label;
      }
    },
    preencheTipoDesconto() {
      if (this.tiposDescontos.length == 0 || this.tiposDescontos == null) {
        return '';
      } else {
        return (this.tiposDescontos.label = this.tiposDescontos.label
          ? this.tiposDescontos.label
          : '');
      }
    },

    preenchePerfilDesconto() {
      return this.selectedPerfil ? this.selectedPerfil.label : '';
    },

    async preencheForm() {
      this.gruposVeiculos = [];
      this.DescontoEscolhido = [];

      this.valorGrupo = 0;
      this.formCadastro.perfisDescontoSelecionados = [];

      if (this.dados.idProduto) {
        this.productsSelect = this.produtos.filter(
          (product) => product.id !== this.dados.idProduto,
        );
        this.formCadastro.valorBaseadoFipe = this.dados.valorBaseadoFipe
          ? parseFloat(this.dados.valorBaseadoFipe).toFixed(2)
          : 0;
        this.formCadastro.idProduto = this.dados.idProduto;
        this.formCadastro.status = this.dados.deletedAt == null ? true : false;

        this.formCadastro.isValorFixo = this.dados.isValorFixo;
        this.formCadastro.isMensal = this.dados.isMensal;
        this.formCadastro.nomeProduto = this.dados.nomeProduto;
        this.formCadastro.nomeProdutoResumo = this.dados.nomeProdutoResumo;

        this.formCadastro.obrigatorio = this.dados.obrigatorio;
        this.formCadastro.porcentagemDescontoMaxima =
          this.dados.porcentagemDescontoMaxima;

        this.formCadastro.grupos = this.dados.Grupos;
        this.gruposVeiculos = this.dados.Grupos;

        this.formCadastro.tiposDescontos = this.dados.tiposDescontos;
        this.DescontoEscolhido = this.dados.ProdutosDescontos;

        this.tiposDeDescontos.forEach((element) => {
          this.DescontoEscolhido.forEach((element2) => {
            if (element.id == element2.idTipoDesconto) {
              element2.descricao = element.label;
            }
          });
        });

        this.formCadastro.visivelProposta = this.dados.visivelProposta;
        this.formCadastro.alterarValor = this.dados.alterarValor;
        this.formCadastro.produtoVisivel = this.dados.produtoVisivel;
        this.formCadastro.isAdicional = this.dados.isAdicional;
        this.formCadastro.requerAssinaturaTermoAdicional =
          this.dados.requerAssinaturaTermoAdicional;
        this.formCadastro.isDesconto = this.dados.isDesconto;

        this.formCadastro.idProdutoEvo = this.dados.idProdutoEvo;

        this.formCadastro.idTipoProduto = this.dados.idTipoProduto;
        this.formCadastro.idFornecedor = this.dados.idFornecedor;
        this.formCadastro.permissionamentoDescontoProduto =
          this.dados.permissionamentoDescontoProduto;
        this.fornecedoresFiltred = this.fornecedores.filter(
          (x) => x.idTipoProduto == this.formCadastro.idTipoProduto,
        );

        this.formCadastro.tiposDescontos = this.dados.tiposDescontos;
        this.DescontoEscolhido = this.dados.ProdutosDescontos;

        this.acrescimosMensalidadeEscolhidos = !JSON.parse(
          this.dados.acrescimoMensalidade,
        )
          ? []
          : JSON.parse(this.dados.acrescimoMensalidade);

        if (this.DescontoEscolhido)
          if (this.dados.produtosLinkados) {
            var aux = this.dados.produtosLinkados.split(',');
            var arrProdAux = [];
            aux.forEach((el) => {
              var list = this.produtos.filter((x) => x.id == el)[0];
              if (list) {
                arrProdAux.push(list);
              }
            });
            this.formCadastro.produtosLinkados = arrProdAux;
          } else this.formCadastro.produtosLinkados = [];

        if (this.dados.sobreporOutrosProdutos) {
          let aux = this.dados.sobreporOutrosProdutos.split(',');
          let arrProdAux = [];
          aux.forEach((el) => {
            var list = this.produtos.filter((x) => x.id == el)[0];
            if (list) {
              arrProdAux.push(list);
            }
          });
          this.formCadastro.sobreporOutrosProdutos = arrProdAux;
        } else this.formCadastro.sobreporOutrosProdutos = [];

        var arrAux = [];
        this.dados.TipoPagamento.forEach((element) => {
          arrAux.push({
            id: element.idTipoPagamentoEmpresa,
            label: element.nomePagamento,
          });
        });
        this.formCadastro.formasPagamentos = arrAux;

        if (this.dados.produtosComplementares) {
          const prodList = [];
          const arrProdComplementares =
            this.dados.produtosComplementares.split(',');

          arrProdComplementares.forEach((idProd) => {
            const produtoEncontrado = this.produtos.filter(
              (prod) => prod.id == idProd,
            );
            if (produtoEncontrado) {
              prodList.push(...produtoEncontrado);
            }
          });
          this.formCadastro.produtosComplementares = prodList;
        } else {
          this.formCadastro.produtosComplementares = [];
        }

        this.formCadastro.formasPagamentos = arrAux;

        const { destinos } = this.dados;

        this.formCadastro.destinos = this.convertSelectData(destinos);

        if (this.dados.idsPerfilDesconto) {
          this.preencheDadosSelectPefilDesconto();
        }

        if (
          this.dados.valorCotaParticipacao ||
          this.dados.valorParticipacaoMinimo
        ) {
          this.formCadastro.valorCotaParticipacao =
            this.dados.valorCotaParticipacao;

          this.formCadastro.valorParticipacaoMinimo =
            this.dados.valorParticipacaoMinimo;
        }

        this.formCadastro.isComplementar = this.dados.isComplementar;
        this.formCadastro.isValorMinimoMensalidade =
          this.dados.isValorMinimoMensalidade;

        if (this.dados.isValorMinimoMensalidade) {
          await this.getRegionais();
          this.formCadastro.idsRegionaisValorMinimoMensalidade =
            this.dados.idsRegionaisValorMinimoMensalidade
              .split(',')
              .map((res) => {
                return +res;
              });
        }

        if (this.dados.idsRegionaisIgnoradas) {
          this.formCadastro.idsRegionaisIgnoradas =
            this.dados.idsRegionaisIgnoradas.split(',').map((res) => {
              return +res;
            });
        }
        this.formCadastro.perfisDescontoSelecionados = this.dados
          .percentualDescontoPerfil
          ? JSON.parse(this.dados.percentualDescontoPerfil)
          : [];

        this.selecionarPerfisDesconto = Boolean(
          this.formCadastro.perfisDescontoSelecionados,
        );
      } else {
        this.resetForm();
      }
    },
    getDecoded() {
      const token = localStorage.getItem('user-token');
      if (token) {
        this.decoded = jwt.decode(token);
        this.id_usuario = this.decoded.id_usuario;
        this.idEmpresa = this.decoded.id_empresa;
      }
    },
    validateState(ref) {
      if (
        this.veeFields[ref] &&
        (this.veeFields[ref].dirty || this.veeFields[ref].validated)
      ) {
        return !this.veeErrors.has(ref);
      }
      return null;
    },
    validateClass(ref) {
      if (
        this.veeFields[ref] &&
        (this.veeFields[ref].dirty || this.veeFields[ref].validated)
      ) {
        return this.veeErrors.has(ref);
      }
      return null;
    },
    onSubmit() {
      this.formCadastro.idEmpresa = this.idEmpresa;

      this.formCadastro.acrescimoMensalidade = this
        .acrescimosMensalidadeEscolhidos.length
        ? JSON.stringify(this.acrescimosMensalidadeEscolhidos)
        : null;

      const { destinos } = this.formCadastro;
      this.formCadastro.destinos = this.convertSelectData(destinos);

      this.formCadastro.idsPerfilDesconto = null;
      if (this.perfisDesconto) {
        for (let i = 0; i < this.perfisDesconto.length; i++) {
          const objeto = this.perfisDesconto[i];
          this.formCadastro.idsPerfilDesconto += objeto.id;

          // Adicionar uma vírgula entre as labels, exceto para a última
          if (i < this.perfisDesconto.length - 1) {
            this.formCadastro.idsPerfilDesconto += ', ';
          }
        }
      }
      if (this.formCadastro.idTipoProduto != this.TIPO_PRODUTO.ADESAO)
        this.formCadastro.valorBaseadoFipe = null;

      if (this.gruposVeiculos.length == 0) {
        this.$vs.notify({
          position: 'top-center',
          title: 'Atenção',
          text: 'É Necessário adicionar os Grupos referentes a este Produto',
          color: 'danger',
        });
        return;
      }

      var action = 'Atualizar';
      this.msgRetorno = 'Dados Atualizados com sucesso';
      if (!this.formCadastro.idProduto) {
        action = 'Adicionar';
      }
      this.formCadastro.grupos = this.gruposVeiculos;
      this.formCadastro.tiposDescontos = this.DescontoEscolhido;

      // Sanitize idsRegionaisValorMinimoMensalidade
      if (this.formCadastro.isValorMinimoMensalidade) {
        if (
          this.formCadastro.idsRegionaisValorMinimoMensalidade &&
          this.formCadastro.idsRegionaisValorMinimoMensalidade.length
        ) {
          if (
            this.formCadastro.idsRegionaisValorMinimoMensalidade.indexOf(-1) >=
            0
          ) {
            this.formCadastro.idsRegionaisValorMinimoMensalidade = '-1';
          } else {
            this.formCadastro.idsRegionaisValorMinimoMensalidade =
              this.formCadastro.idsRegionaisValorMinimoMensalidade.toString();
          }
        } else {
          this.formCadastro.idsRegionaisValorMinimoMensalidade = '-1';
        }
      } else {
        this.formCadastro.idsRegionaisValorMinimoMensalidade = null;
      }

      if (
        this.formCadastro.idsRegionaisIgnoradas &&
        this.formCadastro.idsRegionaisIgnoradas.length
      ) {
        let _idsRegionais;

        if (this.formCadastro.idsRegionaisIgnoradas.indexOf(-1) >= 0) {
          _idsRegionais = this.listRegionais
            .map((regional) => regional.id)
            .join();

          this.formCadastro.idsRegionaisIgnoradas = _idsRegionais;
        } else {
          _idsRegionais = this.formCadastro.idsRegionaisIgnoradas.join();
          this.formCadastro.idsRegionaisIgnoradas = _idsRegionais;
        }
      } else {
        this.formCadastro.idsRegionaisIgnoradas = null;
      }

      this.$validator.validateAll().then((result) => {
        if (result) {
          this.aguardeCadastro = true;
          this.formCadastro.percentualDescontoPerfil = JSON.stringify(
            this.formCadastro.perfisDescontoSelecionados,
          );
          service
            .post('Produto', action, {
              ...this.formCadastro,
              percentualDescontoPerfil: JSON.stringify(
                this.formCadastro.perfisDescontoSelecionados,
              ),
            })
            .then(() => {
              this.aguardeCadastro = false;
              this.$vs.notify({
                position: 'top-center',
                title: 'Atenção',
                text: `Operação Realizada com sucesso`,
                color: 'success',
              });
              this.$emit('concluido');
            })
            .catch((error) => {
              this.aguardeCadastro = false;
              this.$vs.notify({
                position: 'top-center',
                title: 'Atenção',
                text: error,
                color: 'danger',
              });
            });
        }
      });
    },
    clearFormGrupo() {
      this.activePromptValor = false;
      this.grupo = [];
    },
    clearFormDescontos() {
      this.activePromptValor = false;
      this.tiposDescontos = [];
      this.estado = [];
      this.gruposDesconto = [];
      this.percentualDesconto = 0;
      this.tipoProposta = '';
      this.valorFipeInicial = 0;
      this.valorFipeFinal = 0;
    },
    adicionaGrupoProduto() {
      this.activePromptValor = false;
      var auxList = this.gruposVeiculos.filter(
        (x) => x.idGrupo == this.grupo.id,
      );
      if (auxList.length == 0)
        this.gruposVeiculos.push({
          idGrupo: this.grupo.id,
          nomeGrupo: this.grupo.label,
          valor:
            this.formCadastro.isValorFixo == true
              ? this.valorGrupo == null || 0
                ? 0
                : this.valorGrupo
              : null,
        });

      this.grupo = [];
      this.valorGrupo = 0;
    },
    adicionaTipoDeDesconto() {
      this.activePromptDesconto = false;
      this.estadoString = this.estado.toString();

      const arrayComHash = this.gruposDesconto
        ? this.gruposDesconto.map((str) => `#${str}#`)
        : [];

      this.gruposDescontoString = arrayComHash.toString();

      var auxList = this.DescontoEscolhido.filter(
        (x) => x.id == this.tiposDescontos.id,
      );
      if (
        (this.valorFipeInicial === 0 && this.valorFipeFinal === 0) ||
        this.valorFipeFinal > this.valorFipeInicial
      ) {
        if (auxList.length == 0) {
          const objTipoDesconto = {
            idTipoDesconto: this.tiposDescontos.id,
            descricao: this.tiposDescontos.label,
            percentualMaximoDesconto: this.percentualDesconto,
            tipoProposta: this.tipoProposta || '',
            estados: this.estadoString,
            idConsultor: this.id_usuario,
            gruposDesconto: this.gruposDescontoString,
            valorFipeInicial: this.valorFipeInicial,
            valorFipeFinal: this.valorFipeFinal,
          };

          const indexDescontoEscolhido = this.DescontoEscolhido.findIndex(
            (obj) => obj.idTipoDesconto === objTipoDesconto.idTipoDesconto,
          );
          if (indexDescontoEscolhido !== -1) {
            this.DescontoEscolhido[indexDescontoEscolhido] = objTipoDesconto;
          } else {
            this.DescontoEscolhido.push(objTipoDesconto);
          }
        }
      } else {
        this.$vs.notify({
          position: 'top-center',
          title: 'Atenção',
          text: 'O valor final de intervalo da fipe deve ser maior que o valor inicial',
          color: 'danger',
        });
      }

      this.tipoProposta = '';
      this.estadoString = '';
      this.percentualDesconto = 0;
      this.gruposDesconto = '';

      this.tiposDescontos = [];
    },
    adicionaTipoDeDescontoPerfil() {
      const nenhumDescontoOuPerfilSelecionado =
        !this.percentualDescontoPerfil || !this.selectedPerfil;

      if (nenhumDescontoOuPerfilSelecionado) {
        this.$vs.notify({
          position: 'top-center',
          title: 'Desconto para perfil',
          text: 'Preencha o percentual que será aplicado para o desconto.',
          color: 'danger',
        });
        return;
      }

      const { id, label } = this.selectedPerfil;

      const objectSelectedPerfil = {
        id,
        label,
        percentual: this.percentualDescontoPerfil,
      };

      if (this.formCadastro.perfisDescontoSelecionados) {
        const encontrarPerfilPorId = (perfil) => perfil.id === id;
        const perfilEncontrado =
          this.formCadastro.perfisDescontoSelecionados.findIndex(
            encontrarPerfilPorId,
          );

        if (perfilEncontrado !== -1) {
          this.formCadastro.perfisDescontoSelecionados[perfilEncontrado] =
            objectSelectedPerfil;
          this.activePromptDescontoPerfil = false;
          this.clearFormDescontosPerfil();
          return;
        }
      }

      this.formCadastro.perfisDescontoSelecionados.push(objectSelectedPerfil);
      this.activePromptDescontoPerfil = false;
      this.clearFormDescontosPerfil();
    },

    deletaTipoDescontoPerfil(id) {
      this.formCadastro.perfisDescontoSelecionados =
        this.formCadastro.perfisDescontoSelecionados.filter(
          (item) => item.id !== id,
        );
    },
    buscaDadosGrupos() {
      service.getAll('Grupo', {}, 'list/' + this.idEmpresa).then((res) => {
        res.data.forEach((element) => {
          if (element.deletedAt == null)
            this.grupos.push({
              id: element.idGrupo,
              label: element.nomeGrupo,
            });
        });
      });
    },
    buscaDadosTiposPagamento() {
      service
        .getAll('TipoPagamento', {}, 'list/' + this.idEmpresa)
        .then((res) => {
          res.data.forEach((element) => {
            this.formasPagamentos.push({
              id: element.idTipoPagamentoEmpresa,
              label: element.TipoPagamento_domTipoPagamento.nomePagamento,
            });
          });
        });
    },
    buscaDadosSelects(model, array, campoDescricao, campoPK) {
      service.getAll('g', {}, `${model}/list/`).then((res) => {
        res.data = decryptData(res.data);
        res.data.forEach((element) => {
          this[array].push({
            id: element[campoPK],
            label: element[campoDescricao],
          });
        });

        this[array].sort(function (a, b) {
          return a.label < b.label ? -1 : a.label > b.label ? 1 : 0;
        });
      });
    },
    buscaDadosTiposProdutos() {
      service.getAll('g', {}, 'domTipoProdutos/list').then((res) => {
        res.data = decryptData(res.data);
        res.data.forEach((element) => {
          this.tipoProdutos.push({
            id: element.idTipoProduto,
            label: element.nomeTipo,
          });
        });
      });
    },
    buscaDadosFornecedores() {
      service.getAll('g', {}, 'fornecedores/list').then((res) => {
        res.data = decryptData(res.data);
        res.data.forEach((element) => {
          this.fornecedores.push({
            id: element.idFornecedor,
            label: element.nomeFornecedor,
            idTipoProduto: element.idTipoProduto,
          });
        });
        //this.fornecedoresFiltred = [...this.fornecedores];
      });
    },
    buscaDadosTiposDescontos() {
      service.getAll('g', {}, `TiposDescontos/list`).then((res) => {
        res.data = decryptData(res.data);
        res.data.forEach((element) => {
          this.tiposDeDescontos.push({
            id: element.id_tipoDesconto,
            label: element.descricao,
          });
        });
      });
    },
    buscaDadosProdutos() {
      service
        .getAll('g', {}, `produtos/list/idEmpresa/idEmpresa=${this.idEmpresa}`)
        .then((res) => {
          res.data = decryptData(res.data);
          res.data.forEach((element) => {
            this.produtos.push({
              id: element.idProduto,
              label: element.nomeProduto,
            });
          });
        });
    },

    buscaDadosProdutosComplementares() {
      service
        .getAll('Produto', {}, `listComplementares/${this.idEmpresa}`)
        .then((res) => {
          res.data.forEach((element) => {
            this.produtosComplementares.push({
              id: element.idProduto,
              label: element.nomeProduto,
            });
          });
        })
        .catch(() =>
          this.$vs.notify({
            position: 'top-center',
            title: 'Atenção',
            text: 'Erro ao buscar produtos complementares',
            color: 'danger',
          }),
        );
    },

    buscaDadosProdutosEvo() {
      service.getAll('Produto', {}, `ListarProdutosEvo`).then((res) => {
        this.produtosEvo = [
          {
            id: null,
            label: 'Selecione',
          },
        ];
        res.data.forEach((element) => {
          this.produtosEvo.push({
            id: element.idProdutoEvo,
            label: element.nomeProduto + ' - ' + element.nomeFornecedor,
          });
        });
      });
    },
    resetForm() {
      this.formCadastro = {
        isValorFixo: null,
        isMensal: null,
        status: true,
        nomeProduto: '',
        obrigatorio: null,
        formasPagamentos: null,
        grupos: null,
        porcentagemDescontoMaxima: null,
        visivelProposta: null,
        produtoVisivel: 1,
        produtosLinkados: null,
        sobreporOutrosProdutos: null,
        isAdicional: null,
        requerAssinaturaTermoAdicional: null,
        isDesconto: null,
        idProdutoEvo: null,
        idTipoProduto: null,
        idFornecedor: null,
        tiposDeDescontos: null,
        valorBaseadoFipe: null,
        perfisDesconto: [],
        produtosComplementares: null,
        isComplementar: null,
        idsRegionaisIgnoradas: null,
        isValorMinimoMensalidade: false,
        idsRegionaisValorMinimoMensalidade: [],
        perfisDescontoSelecionados: [],
      };
      this.percentualDesconto = 0;
    },
    onReset(evt) {
      if (this.sideBar == true) {
        this.$emit('cancel');
      } else {
        evt.preventDefault();
        this.resetForm();
        this.$nextTick(() => {
          this.show = true;
        });
      }
    },
    convertSelectData(data) {
      data =
        data == undefined || data == null || data.length == 0 || !data
          ? ''
          : data;

      const hasData = data.length;
      const dataType = typeof data;
      if (hasData && dataType === 'string') return data.split(',');

      if (Array.isArray(data)) return data.join(',');

      return data;
    },

    buscaDadosPerfil(model, array, campoDescricao, campoPK) {
      service
        .getAll('g', {}, `${model}/list/idEmpresa/idEmpresa=${this.idEmpresa}`)
        .then((res) => {
          res.data = decryptData(res.data);
          res.data.forEach((element) => {
            this[array].push({
              id: element[campoPK],
              label: element[campoDescricao],
              estado: element.estado,
              cidade: element.cidade,
            });
          });
        })
        .catch(() => {
          this.$vs.loading.close();
          this.$vs.notify({
            position: 'top-center',
            title: 'Atenção',
            text: 'Perfil não pode ser encontrado',
            color: 'danger',
          });
        });
    },
    preencheDadosSelectPefilDesconto() {
      this.perfisDesconto = [];
      this.selecionarPerfisDesconto = true;
      const ids = this.dados.idsPerfilDesconto
        .split(', ')
        .map((id) => id.trim());
      ids.forEach((el) => {
        const perfisSelecionados = this.perfis.filter((x) => x.id == el)[0];
        if (perfisSelecionados) {
          this.perfisDesconto.push(perfisSelecionados);
        }
      });
    },
    async getRegionais() {
      if (this.listRegionais.length > 0) {
        return;
      }
      try {
        this.$vs.loading();

        this.listRegionais = await regionaisService.buscaRegionais(null);

        this.listRegionais.unshift({
          id: -1,
          label: 'Todas',
        });
      } catch (error) {
        notify.notifyFail(this.$vs, error);
      } finally {
        this.$vs.loading.close();
      }
    },
    showDescontoPopup(value) {
      this.selectedPerfil = { ...value };

      const existeLabelEPorcentual = value.label && value.percentual;

      if (existeLabelEPorcentual) {
        this.percentualDescontoPerfil = value.percentual;
      }

      this.activePromptDescontoPerfil = true;
    },
    clearFormDescontosPerfil() {
      this.selectedPerfil = null;
      this.activePromptDescontoPerfil = false;
      this.perfisDesconto = [];
      this.percentualDescontoPerfil = 0.0;
      this.descontoPerfil = {
        id: null,
        label: '',
        percentual: null,
      };
    },

    /**
     * Limpa os dados do modal de acréscimos do valor da mensalidade
     */
    limpaAcrescimo() {
      this.estadoAcrescimo = [];
      this.porcentagemAcrescimo = 0;
    },

    /**
     * Adiciona um novo acréscimo do valor da mensalidade
     */
    adicionaAcrescimo() {
      if (this.porcentagemAcrescimo <= 0) {
        notify.notifyFail(
          this.$vs,
          'É necessário um valor maior que zero para fazer um acréscimo do valor.',
        );
        return;
      }

      if (!this.verificaExisteEstadoSelecionado()) {
        return;
      }

      const obj = {
        uf: this.estadoAcrescimo,
        valor: this.porcentagemAcrescimo,
      };
      this.acrescimosMensalidadeEscolhidos.push(obj);

      this.activePromptAcrescimo = false;
      this.limpaAcrescimo();
    },

    /**
     * Verifica, ao adicionar um novo acréscimo com estado, se esse estado selecionado já foi selecionado em outra configuração
     * de acréscimo anterior, não permitindo que um mesmo estado possua mais de uma configuração de acréscimo de valor de mensalidade.
     * @return {boolean} true se a verificação for validada, false se for invalidada
     */
    verificaExisteEstadoSelecionado() {
      const arrayEstadosConfig = this.acrescimosMensalidadeEscolhidos.map(
        (config) => config.uf,
      );

      const estadosSelecionados = arrayEstadosConfig.flat();

      const existeEstadoSelecionado = estadosSelecionados.some((estado) =>
        this.estadoAcrescimo.includes(estado),
      );

      if (existeEstadoSelecionado) {
        notify.notifyFail(
          this.$vs,
          'Não é possível ter configurações diferentes para um estado que já foi selecionado.',
        );
        return false;
      }

      return true;
    },

    /**
     * Displays details of a discount type based on the provided 'item'.
     *
     * @param {Object} item - The object containing information about the discount type.
     * @param {string} [item.gruposDesconto] - A string containing discount groups separated by '#' to be displayed.
     */
    detalhesTipoDesconto(item) {
      if (item) {
        // Display discount details
        this.detalhesDesconto = true;

        // Store the details for further reference
        this.auxDetalhesDesconto = item;

        // Replace '#' characters with spaces in discount groups if present
        if (item.gruposDesconto) {
          this.auxDetalhesDesconto.gruposDesconto = item.gruposDesconto.replace(
            /#/g,
            ' ',
          );
        }
      }
    },

    /**
     * Edits the information of a discount type based on the data provided by the 'item' object.
     *
     * @param {Object} item - The object containing information about the discount type to be edited.
     * @param {string} [item.estados] - A string containing states separated by commas.
     * @param {string} [item.gruposDesconto] - A string containing discount groups separated by commas and enclosed in '#'.
     * @param {number} [item.percentualMaximoDesconto] - The maximum percentage of discount.
     * @param {string} [item.tipoProposta] - The type of proposal.
     * @param {number} [item.valorFipeInicial] - The initial value from the FIPE table.
     * @param {number} [item.valorFipeFinal] - The final value from the FIPE table.
     */
    editaTipoDesconto(item) {
      if (item.estados) {
        this.estado = item.estados.split(',');
      }
      if (item.gruposDesconto) {
        const arrayComHash = item.gruposDesconto.split(',');
        this.gruposDesconto = arrayComHash.map((str) => str.slice(1, -1));
      }
      if (item.percentualMaximoDesconto) {
        this.percentualDesconto = item.percentualMaximoDesconto;
      }
      if (item.tipoProposta) {
        this.tipoProposta = item.tipoProposta;
      }
      if (item.valorFipeInicial && item.valorFipeFinal) {
        this.valorFipeInicial = item.valorFipeInicial;
        this.valorFipeFinal = item.valorFipeFinal;
      }
      this.tiposDescontos = { id: item.idTipoDesconto, label: item.descricao };
    },
    editaTipoDescontoPerfil(item) {
      if (item) {
        const editPerfil = { ...item };

        this.showDescontoPopup(editPerfil);
      }
    },
  },
  created() {
    this.getDecoded();
    this.buscaDadosPerfil('perfis', 'perfis', 'nomePerfil', 'idPerfil');
  },
  mounted() {
    this.buscaDadosGrupos();
    this.buscaDadosTiposPagamento();
    this.buscaDadosProdutos();
    this.buscaDadosProdutosComplementares();
    this.buscaDadosProdutosEvo();
    this.buscaDadosTiposProdutos();
    this.buscaDadosFornecedores();
    this.buscaDadosTiposDescontos();
    this.buscaDadosSelects('domUf', 'estados', 'nomeUf', 'codUf');
    this.TIPO_PRODUTO_CASCO = TIPO_PRODUTO.TIPO_PRODUTO_CASCO;
    this.getRegionais();
  },
  components: {
    Money,
    BotaoSubmit,
    'v-select': vSelect,
    'vs-number': Money,
  },
};
</script>
<!------------ END SCRIPT ------------>

<style scoped>
.div-show {
  display: 'block';
}
.div-hide {
  display: none;
}

li.activeChild {
  border-bottom: 1px solid rgba(var(--vs-primary), 1) !important;
}

div.firstInputTab {
  margin-top: 20px;
}
</style>
